import React from 'react'
import '../../App.css';

const Footer = () => {
  return (
         <footer>
            <h3  className='lead'>
            <em>NOLIVO, SANSANO & ASOCIADOS</em>
            <em className='m-2'>Copyright Nolivo, Sansano & Asociados 2013-2021</em>
            <p className='m-2'>© 2013— 2022</p>
        </h3>
    </footer>
  )
}

export default Footer